import logo from "./logo.png";
import rose from "./rose.png";
import greenMe from "./greenMe.png";
import pawfectMatch from "./PawfectMatchLogo.png";
import noteTakerPlaceholder from "./noteTaker.png";
import budget from "./budget.png"

export const logoImg = logo;

export const roseImg = rose;

export const greenMeImg = greenMe;
export const PawfectMatchLogo = pawfectMatch;
export const noteTaker = noteTakerPlaceholder;
export const budgetApp = budget;
export * from "./icons";
